import * as api from "../constants/api";
import axios from "../services/axios";
import { getErrorMessageFromAxiosError } from "../utils/axiosUtils";

import { addFlashMessage } from "./FlashMessagesAction";

export const putStedbeskrivelse =
  (
    stedbeskrivelseId,
    payload,
    getSingleAfterUpdateSuccess,
    getAllAfterUpdateSuccess,
    getHistorikkAfterUpdateSuccess,
  ) =>
  async (dispatch) => {
    return axios
      .put(api.PUT_STEDSBESKRIVELSE_URL(stedbeskrivelseId), payload)
      .then((response) => {
        dispatch(
          addFlashMessage({ type: "success", text: "Lagret endringer" }),
        );
        if (getSingleAfterUpdateSuccess) {
          getSingleAfterUpdateSuccess();
        }
        if (getAllAfterUpdateSuccess) {
          getAllAfterUpdateSuccess();
        }
        if (getHistorikkAfterUpdateSuccess) {
          getHistorikkAfterUpdateSuccess();
        }

        let result = response && response.data && response.data.result;
        return Promise.resolve(result);
      })
      .catch((error) => {
        const errText = getErrorMessageFromAxiosError(error);
        dispatch(
          addFlashMessage({
            type: "error",
            text: (typeof errText === "string" && errText) || error.message,
          }),
        );
        return Promise.reject(error);
      });
  };
